
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/latest-updates/[slug]",
      function () {
        return require("private-next-pages/latest-updates/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/latest-updates/[slug]"])
      });
    }
  